import { Component, ErrorInfo, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { AppButton } from '../buttons';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  private handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  public render() {
    if (this.state.hasError) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="100vh"
          p={3}
        >
          <Typography variant="h4" gutterBottom color="error">
            Oops! Something went wrong
          </Typography>
          <Typography variant="body1" color="text.secondary" mb={3}>
            {this.state.error?.message || 'An unexpected error occurred'}
          </Typography>
          <AppButton variant="primary" onClick={this.handleReset}>
            Return to Home
          </AppButton>
        </Box>
      );
    }

    return this.props.children;
  }
}
